import { Button } from "@at/design-system-elements";
import {
  TypeDiscovery,
  TypeMini,
  ThemeSelectors,
} from "@at/design-system-foundation";
import styled from "styled-components";

import { PrintStyleSheet } from "../../../../seller/advert-seller-details/location/location.styles";

export const LeasingProductPriceArea = styled.div`
  border-radius: 5px;
  padding: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  position: sticky;
  overflow: hidden;
  bottom: 0;
  z-index: 3;
  width: 100%;
  background-color: white;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.16),
    0px 0px 0px 0px rgba(0, 0, 0, 0.1);
  @media (min-width: 950px) {
    z-index: 1;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.16),
      0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  }
  @media print {
    position: relative;
    display: block;
    page-break-after: always;
  }
`;
export const LeasingProductPriceWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};

  // NOTE: this should not be required, but there's an issue with styles being removed during SSR/rehydration
  > ul {
    margin: 0;
    padding: 0;
  }
`;

export const PriceDetails = styled.div`
  color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
  line-height: 1;
  width: 60%;
`;

export const Price = styled(TypeDiscovery)`
  color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
  display: block;
`;

export const PriceTimescale = styled(TypeMini)`
  color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
  display: block;
  position: relative;
  top: -4px;
`;

export const PriceDetailsIntro = styled(TypeMini)`
  color: ${({ theme }) => ThemeSelectors.getCopyColor(theme)};
  display: block;
`;

export const PriceBreakdown = styled(TypeMini).attrs(() => ({ as: "ul" }))`
  color: ${({ theme }) => ThemeSelectors.getCopyColor(theme)};
  display: block;
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const PriceBreakdownItem = styled(TypeMini).attrs(() => ({ as: "li" }))`
  color: ${({ theme }) => ThemeSelectors.getCopyColor(theme)};

  strong {
    font-variation-settings: "wght" 500;
  }
`;

export const LeasingProductOrderButtons = styled.div`
  display: flex;
  flex-direction: column;
  ${PrintStyleSheet}

  @media (min-width: 320px) {
    flex-direction: row;
    column-gap: ${({ theme }) => ThemeSelectors.getGroupThreeSpacing(theme)};
  }
`;

export const LeasingContactUsButton = styled(Button)`
  padding-inline: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
  width: 100%;
`;
